// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__n7y3x","inputDescription":"styles_inputDescription__3ZiXB"};